import { graphql, useStaticQuery } from "gatsby"

export const usePressSidebar = () => {
  const data = useStaticQuery(
    graphql`
      {
        sidebar: contentfulText(title: { eq: "Press sidebar" }) {
          rtContent {
            raw
          }
        }
        backText: contentfulMicrocopy(contentful_id: { eq: "4DEd1tBIplWxQcM4fR6Q3j" }) {
          text
        }
      }
    `
  )
  return data
}
